import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ArrowRightOutlineIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M12.1553 18.7437L18.1623 12.7366L2 12.7366V10.7368H18.1734L12.1843 4.74757L13.5985 3.33334L21.9962 11.7312L13.5695 20.1579L12.1553 18.7437Z",
    fill: "currentColor"
  }));
}